import SelectMenuTypology from "./SelectMenuTypology";

export default SelectMenuTypology;
